import { apiGetList, apiPost, apiPut, apiDelete } from "services/api";

export const getPromotions = () =>
  apiGetList("promotions", { page: 1, pageSize: 1000 });

export const createPromotion = (payload) =>
  apiPost("promotions/create", payload);

export const updatePromotion = (payload) =>
  apiPut("promotions/update", payload);

export const deletePromotion = (stockid) =>
  apiDelete("promotions", { stockid: Number(stockid) });
